(() => {
  const sections = new Map();
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  function initialize() {
    document.querySelectorAll('script[data-hc033-section]').forEach((script) => {
      const section = document.getElementById('shopify-section-' + script.dataset.hc033Section);
      if (!section || sections.has(section)) return;

      let reviewBlock;
      function positionReviews() {
        if (!section.isConnected) return;
        if (!reviewBlock) {
          const widget = section.querySelector('.product-single__meta .yotpo-reviews-star-ratings-widget');
          reviewBlock = widget?.closest('.shopify-app-block');
        }
        if (!reviewBlock) return;
        const header = section.querySelector(mobileQuery.matches
          ? '.product-single__header--mobile'
          : '.product-single__meta .product-single__header');
        const title = header?.querySelector('.product-single__title');
        if (!title) return;
        reviewBlock.classList.add('hc033-reviews');
        if (title.nextElementSibling !== reviewBlock) title.after(reviewBlock);
        observer.disconnect();
      }

      const observer = new MutationObserver(positionReviews);
      observer.observe(section, { childList: true, subtree: true });
      mobileQuery.addEventListener('change', positionReviews);
      sections.set(section, () => {
        observer.disconnect();
        mobileQuery.removeEventListener('change', positionReviews);
      });
      positionReviews();
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', (event) => {
    const cleanup = sections.get(event.target);
    if (cleanup) {
      cleanup();
      sections.delete(event.target);
    }
  });
})();
